import type { FuelCardVehicle, FuelTransactionBodyContent } from '@cobliteam/common-types';
import type { FuelCardVehicleAPI, SaveFuelTransactionAPI, ZendeskTicketAPI } from './Definitions/APITypes';
import type { ZendeskTicket } from './Definitions/Types';

export const toSaveFuelTransactionBody = (body: FuelTransactionBodyContent): SaveFuelTransactionAPI => ({
  transaction_time: body.transactionTime,
  vehicle_id: body.vehicleId,
  odometer_in_km: body.odometerInKm,
  driver_name: body.driverName,
  fuel_type: body.fuelType,
  total_cost: body.totalCost,
  quantity_in_liters: body.quantityInLiters,
  merchant: body.merchant,
});

export const toFuelVehicle = (fuelVehicleApi: FuelCardVehicleAPI): FuelCardVehicle => ({
  id: fuelVehicleApi.id,
  vehicleId: fuelVehicleApi.vehicle_id,
  integrationId: fuelVehicleApi.integration_id,
  licensePlate: fuelVehicleApi.license_plate,
  model: fuelVehicleApi.model,
  refConsumption: fuelVehicleApi.ref_fuel_consumption,
});

export const fuelVehiclesTransformer = (response: FuelCardVehicleAPI[]): FuelCardVehicle[] => response.map(toFuelVehicle);

export const openNewFuelCardTicketToOpenNewFuelCardTicketAPI = (zendeskTicket: ZendeskTicket): ZendeskTicketAPI => ({
  problem: zendeskTicket.problem,
  message: zendeskTicket.message,
  fleet_name: zendeskTicket.fleetName,
  fleet_id: zendeskTicket.fleetId,
  user_name: zendeskTicket.userName,
  user_email: zendeskTicket.userEmail,
});
